<template>
1:1 채팅 신청 팝업
    <teleport to="body" >
        <div class="backdrop">
            <div class="dialog">
                <section>
                    <slot></slot>

                    <div class="user-info">
                        고니안내
                    </div>
                    <div class="ment">
                        회원이 1:1 채팅을 요청하셨습니다.<br>수락하시겠습니까?
                    </div>
                </section>
                <menu>
                    <slot name="actions">
                        <div class="btn_wrap"><base-button @click="tryAccept" mode="darkblue">수락</base-button></div>
                        <div class="btn_wrap"><base-button @click="tryClose"  mode="outline_gray">거절</base-button></div>
                    </slot>
                </menu>
            </div>
        </div>
    </teleport>
</template>
<script>

export default{

}
</script>
<style lang="scss" scoped>
.backdrop {
  position: fixed;
  top: 0;
  left: 0;
  height: 100vh;
  width: 100%;
  background-color: rgba(0, 0, 0, 0.3);
  z-index: 10;
}
.dialog {
  position: fixed;
  top: 20vh;
  left: 25%;
  width: 50%;
  z-index: 100;
  border-radius: 5px;
  border: none;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.26);
  padding: 0;
  margin: 0;
  overflow: hidden;
  background-color: white;
  section{
      text-align:center;
      .user-info{
        font-size: 18px;
        font-weight: bolder;
        color: #323232;
        cursor: pointer;
        margin:40px 0;
        font-family:맑은고딕,malgungothic;
      }
      .ment{
        padding: 13px 0;
        margin: 18px 30px 0;
        color: #606060;
        background-color: #dedede;
        border-radius: 5px;
      }
      .ment:before {
        content: "";
        display: inline-block;
        width: 0;
        height: 0;
        position: absolute;
        -webkit-transform: translateX(-50%);
        transform: translateX(-50%);
        left: 50%;
        border-left: 7px solid transparent;
        border-right: 7px solid transparent;
        top:113px;
        border-bottom: 10px solid #dedede;
    }
  }
  menu{
    padding: 1rem;
    display: flex;
    justify-content: center;
    margin: 0;
    .btn_wrap{
        width:40%;
        padding:5px;
    }

  }
}
</style>
